<template>
    <div id="createFromInve">
        <a-modal v-model="visible" width="60%" :title="$t('publicLang.SKUSearch')" on-ok="handleOk">
            <template slot="footer">
                <a-button type="primary" @click="saveTable">{{ $t('publicLang.Save')}}</a-button>
            </template>
            <a-row>
                <a-row style="margin-bottom: 10px;" type="flex" justify="space-between">
                    <a-col>
                        <a-input-search size="small" v-model="skuVal" :placeholder="$t('reportSetting.plInpuSku')" enter-button @search="SearchTable" />
                    </a-col>
                    <a-col>
                        <a-pagination
                                :pageSizeOptions="page.pageSizeOptions"
                                :showTotal="total => `${$t('generic.totalOf')} ${page.pagingTotal} ${$t('generic.Records')}`"
                                size="small"
                                :total="page.pagingTotal"
                                v-model="page.currentVal"
                                :pageSize.sync="page.pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                showSizeChanger

                        />
                    </a-col>
                </a-row>
                <a-row>
                    <vxe-table
                            border
                            resizable
                            highlight-hover-row
                            ref="createDromInvRef"
                            width="80%"
                            size="mini"
                            :data="skuTable">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="sku" :title="$t('pubGicSet.SKU')" minWidth="100"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="skuDesc" :title="$t('pubGicSet.SkuDesc')" minWidth="250"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="warehouseCode" :title="$t('pubGicSet.WarehouseCode')" minWidth="100"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="logicalWh" :title="$t('pubGicSet.LogicalWH')" minWidth="100"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="orderType" :title="$t('pubGicSet.OrderType')" minWidth="100"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="avQty" :title="$t('pubGicSet.AvailableQty')" minWidth="100"></vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
     import cookie from '../../../api/cookie'
    export default{
        data(){
            return{
                visible: false,
                skuSearchInfo: '',
                skuVal: null,
                parantUid: '',
                skuTable: [],
                page: {
                    pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal: 10,
                    currentVal:1,
                    pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30')
                }
            }
        },
        methods:{
            //      选择条数
            onShowSizeChange(current, pageSize) {
                this.page.currentVal = current;
                this.page.pagingSize = pageSize;
                this.show(this.parantUid);
            },
            //      表格分页
            tableChangePage(current) {
                this.page.currentVal = current;
                this.show(this.parantUid);
            },
            show(id){
                this.parantUid = id
                this.visible = true
                let  params= {
                    soHeaderUid: this.parantUid,
                    pageNum: this.page.currentVal,
                    pageSize: this.page.pagingSize,

                }
                if(this.skuVal != null && this.skuVal != ''){
                    params.skuList = [this.skuVal]
                }else{
                    params.skuList = []
                }
                ajax.post(api.SOINVSKU,params).then(res=>{
                    this.page.pagingTotal = res.data.totalElements
                    this.skuTable = res.data.invSkuSoLookupViews
                })
            },
            SearchTable(){
                this.page.currentVal = 1
                this.show(this.parantUid)
            },
            saveTable(){
                let arr = this.$refs.createDromInvRef.getCheckboxRecords()
                if(arr.length > 0 ){
                    let uids = []
                    for(let i in arr){
                        uids.push(arr[i].uid)
                    }
                    let params = {
                        soHeaderUid: this.parantUid,
                        uids: uids
                    }
                    ajax.post(api.SOCREATESODETAIL,params).then(res=>{
                        if(res.code == 200){
                            this.visible = false
                            this.skuVal = []
                            this.$emit("cancelImport", "init");
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                }
            }
        }
    }
</script>